/**
 * Organization Role Badge Component
 * 
 * Visual indicator for user organization roles with appropriate
 * icons and color coding.
 */

import { Badge } from '@/components/ui/badge';
import { Crown, Star, User } from 'lucide-react';

interface OrgRoleBadgeProps {
  role: 'owner' | 'super_user' | 'member' | string;
}

export function OrgRoleBadge({ role }: OrgRoleBadgeProps) {
  const config = {
    owner: { 
      variant: 'default' as const, 
      label: 'Owner', 
      icon: Crown,
      className: 'bg-primary text-primary-foreground'
    },
    super_user: { 
      variant: 'secondary' as const, 
      label: 'Super User', 
      icon: Star,
      className: 'bg-secondary text-secondary-foreground'
    },
    member: { 
      variant: 'outline' as const, 
      label: 'Member', 
      icon: User,
      className: 'border-border'
    },
  };
  
  const roleConfig = config[role as keyof typeof config] || config.member;
  const Icon = roleConfig.icon;
  
  return (
    <Badge variant={roleConfig.variant} className={roleConfig.className}>
      <Icon className="h-3 w-3 mr-1" />
      {roleConfig.label}
    </Badge>
  );
}
